import Skeleton from "./Skeleton"

export default function CreateGameLoading() {
  return (
    <div className="flex h-screen flex-1 flex-col p-4">
      <Skeleton h={60} />
      <div className="my-3 flex gap-x-3">
        <Skeleton h={35} style={"w-1/2"} />
        <Skeleton h={35} style={"w-1/2"} />
      </div>
      <Skeleton h={50} />
      <Skeleton h={30} w={200} style="my-2" />
      <Skeleton h={80} />
      <Skeleton h={80} style="mt-2" />
    </div>
  )
}
